import React  from 'react';
import { Route,Switch} from 'react-router-dom';

import Departments from './Department';
import DepartmentsAddEdit from './Department/addEdit';
import Course from './Course';
import CourseAddEdit from './Course/addEdit';
import CourseYear from './CourseYear';
import CourseYearAddEdit from './CourseYear/addEdit';
import CourseSemester from './CourseSemester';
import CourseSemesterAddEdit from './CourseSemester/addEdit';

import FeesStructure from './FeesStructure';
import FeesStructureAddEdit from './FeesStructure/addEdit';
 
export  const Departmentroutes = [
    {
        path: '/department',
        name:'Department',
        component: Departments,
        show:true,
    },
    {
        path: '/department-action',
        component: DepartmentsAddEdit
    },
    {
        path: '/course',
        name:'Course',
        component: Course,
        show:true,
    },
    {
        path: '/course-action',
        component: CourseAddEdit
    },
    {
        path: '/course-action/:id', 
        component: CourseAddEdit
    },
    {
        path: '/course-year',
        name:'Course Year',
        component: CourseYear,
        show:true,
    },
    {
        path: '/course-year-action',
        component: CourseYearAddEdit
    },
    {
        path: '/course-year-action/:id', 
        component: CourseYearAddEdit
    }, 
    {
        path: '/course-semester',
        name:'Course Semester',
        component: CourseSemester,
        show:true,
    },
    {
        path: '/course-semester-action',
        component: CourseSemesterAddEdit
    },
    {
        path: '/course-semester-action/:id', 
        component: CourseSemesterAddEdit
    },
    {
        path: '/fees-structure',
        name:'Fees Structure',
        component: FeesStructure,
        show:true,
    },
    {
        path: '/fees-structure-action',
        component: FeesStructureAddEdit
    },
    {
        path: '/fees-structure-action/:id', 
        component: FeesStructureAddEdit
    } 
];

const Department = (props) => {
    return(
        <Switch>
            {Departmentroutes.map((route) => 
                <Route exact
                    key={route.path}
                    path={`${props.match.url}${route.path}`}
                    component={route.component}
                />
            )} 
        </Switch> );
};
export default Department; 


// WEBPACK FOOTER //
// ./src/components/Department/index.js